import React, { useState } from 'react'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { DrawerQAQCResultCP } from 'modules/reports/screens/screen-charts/content/qaqc/DrawerQAQCResultCP'

interface ICPProps {
	executionCode: number
	identification?: string
}

/**
 * Abre drawer full-width com o resultado da execução QAQC (get).
 */
export function ButtonViewQAQCResultCP(props: ICPProps): JSX.Element {

	const [visible, setVisible] = useState<boolean>(false)

	return (
		<>
			<ButtonCP
				tooltip={'Ver resultado'}
				icon={'eye'}
				onClick={() => setVisible(true)}
				size={'small'}
				type={'ghost'}
			/>
			<DrawerQAQCResultCP
				executionCode={props.executionCode}
				title={props.identification}
				visible={visible}
				onClose={() => setVisible(false)}
			/>
		</>
	)
}
